import React from 'react';
import compose from 'recompose/compose';
import Card from '@material-ui/core/Card';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import { translate } from 'react-admin';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router';

const style = theme => ({
  formControl: {
    minWidth: 250,
    marginRight: '5em',
    marginLeft: '5em',
    display: 'flex',
    flexWrap: 'wrap',
  },
});

const Report = ({ translate, classes, history }) => (
  <Card>
    <List>
      <ListItem>
        <ListItemText primary={translate('resources.reports.name')} />
      </ListItem>
      <ListItem>
        <FormControl className={classes.formControl}>
          <Button variant="contained" color="primary" onClick={() => history.push('/reports')}>
            {translate('resources.reports.fields.getReport')}
          </Button>
        </FormControl>
      </ListItem>
    </List>
  </Card>
);

const enhance = compose(withStyles(style), translate, withRouter);

export default enhance(Report);
